import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * A utility function to merge tailwind classes with clsx classes
 * @param classes - The classes to merge
 * @returns
 */
export function cn() {
  for (var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++) {
    classes[_key] = arguments[_key];
  }
  return twMerge(clsx(classes));
}